import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    target: String,
  };

  toggleAllHouses(event) {
    const selectAllCheckbox = event.target;
    const houseCheckboxes = this.element.querySelectorAll(".house-checkbox");

    houseCheckboxes.forEach((checkbox) => {
      checkbox.checked = selectAllCheckbox.checked;
    });
  }

  toggleAll(event) {
    const selectAllCheckbox = event.target;
    const targetClass = this.targetValue || ".checkbox-item";
    const checkboxes = this.element.querySelectorAll(targetClass);

    checkboxes.forEach((checkbox) => {
      checkbox.checked = selectAllCheckbox.checked;
    });
  }
}
